import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, LockIcon, FileTextIcon, ClockIcon, GlobeIcon, UsersIcon } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-6 pb-10 md:pt-10 md:pb-16 px-4 overflow-hidden bg-dark-DEFAULT" data-id="element-118">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-5xl h-full opacity-15 pointer-events-none" data-id="element-119">
        <div className="absolute top-10 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-brand-DEFAULT rounded-full blur-[120px]" data-id="element-120"></div>
      </div>

      <div className="max-w-2xl mx-auto relative z-10 flex flex-col items-center text-center" data-id="element-121">
        {/* Brand label */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="flex items-center space-x-2 mb-4" data-id="element-122">
          <span className="text-xl" data-id="element-123">🏐</span>
          <span className="text-brand-DEFAULT font-bold tracking-widest uppercase text-sm" data-id="element-124">
            EDULABS
          </span>
        </motion.div>

        {/* Title */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-5xl md:text-7xl lg:text-8xl font-bebas leading-[0.9] mb-4" data-id="element-125">
          <span className="text-white" data-id="element-126">Todo tu año de Vóley</span>
          <br data-id="element-127" />
          <span className="text-brand-gold" data-id="element-128">resuelto.</span>
        </motion.h1>

        {/* Mockup Image — right after title */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.92
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative w-full max-w-md mb-6" data-id="element-129">
          <div className="absolute inset-0 bg-brand-DEFAULT/15 rounded-2xl blur-3xl pointer-events-none" data-id="element-130"></div>
          <img src="https://cdn.magicpatterns.com/uploads/gZav6PDjjzYAmyBiQ7pCo4/d873b930-0505-4d3d-b282-39afea4a44a1.png" alt="EDULABS MegaPack Voley Listo" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-131" />
        </motion.div>

        {/* Description */}
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="text-base md:text-lg text-text-secondary max-w-lg mb-6" data-id="element-132">
          El sistema para entrenadores de vóley: año completo listo (sesiones +
          técnica + táctica + drills + gestión + negocio), sin buscar ni armar
          desde cero.
        </motion.p>

        {/* Badges */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.35
      }} className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-133">
          <div className="flex items-center space-x-1.5 text-sm bg-dark-card border border-dark-border px-3 py-1.5 rounded-md text-brand-gold" data-id="element-134">
            <FileTextIcon size={16} className="text-brand-gold" data-id="element-135" />
            <span data-id="element-136">PDF</span>
          </div>
          <div className="flex items-center space-x-1.5 text-sm bg-dark-card border border-dark-border px-3 py-1.5 rounded-md text-brand-gold" data-id="element-137">
            <ClockIcon size={16} className="text-brand-gold" data-id="element-138" />
            <span data-id="element-139">Acceso Inmediato</span>
          </div>
          <div className="flex items-center space-x-1.5 text-sm bg-dark-card border border-dark-border px-3 py-1.5 rounded-md text-brand-gold" data-id="element-140">
            <GlobeIcon size={16} className="text-brand-gold" data-id="element-141" />
            <span data-id="element-142">Habla Hispana</span>
          </div>
          <div className="flex items-center space-x-1.5 text-sm bg-dark-card border border-dark-border px-3 py-1.5 rounded-md text-brand-gold" data-id="element-143">
            <UsersIcon size={16} className="text-brand-gold" data-id="element-144" />
            <span data-id="element-145">Todos los niveles</span>
          </div>
        </motion.div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="w-full space-y-4" data-id="element-146">
          <motion.button onClick={scrollToPricing} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full bg-brand-DEFAULT hover:bg-brand-hover text-white font-bebas text-2xl px-10 py-4 rounded-xl uppercase tracking-wide shadow-[0_0_30px_rgba(255,107,0,0.3)] transition-all" data-id="element-147">
            💪 QUIERO MI MEGAPACK AHORA
          </motion.button>

          <div className="flex flex-col sm:flex-row sm:items-center justify-center space-y-2 sm:space-y-0 sm:space-x-6 text-sm text-text-secondary" data-id="element-148">
            <div className="flex items-center justify-center space-x-2" data-id="element-149">
              <ShieldCheckIcon size={16} className="text-text-secondary" data-id="element-150" />
              <span data-id="element-151">Garantía 7 días sin preguntas</span>
            </div>
            <div className="flex items-center justify-center space-x-2" data-id="element-152">
              <LockIcon size={16} className="text-text-secondary" data-id="element-153" />
              <span data-id="element-154">Pago 100% seguro · Tarjeta · PayPal · Transferencia</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}